import { useCallback, useMemo } from 'react';

import { useSaveWorkspaceMutation } from '@/api/workspace/index.ts';
import { useAppStore } from '@/store/hooks.ts';
import { saveWorkspace } from '@/store/workspace/saveWorkspace.ts';

const MUTATION_FIXED_CACHE_KEY = 'use-save-workspace-mutation-cache-key';

export function useSaveWorkspace() {
  const { getState, dispatch } = useAppStore();
  const [_, mutationInfos] = useSaveWorkspaceMutation({ fixedCacheKey: MUTATION_FIXED_CACHE_KEY });

  const saveWorkspaceConnected = useCallback(() => {
    saveWorkspace({ getState, dispatch, mutationCacheKey: MUTATION_FIXED_CACHE_KEY });
  }, [getState, dispatch]);

  return useMemo(
    () => ({ saveWorkspace: saveWorkspaceConnected, ...mutationInfos }),
    [saveWorkspaceConnected, mutationInfos],
  );
}
